import { Link } from 'react-router-dom';
import './Results.css'
let Results=(props)=>{
    let ResultDownloadfun=(e)=>{
        props.resultfuncall(e);
    }
    return(
        <div className='maincontresult'>
            <div className='subcontresult'>
                <h2 className='resultheading'>Result</h2>
                {
                    props.singledata !== "" ? props.singledata.map(
                        dd=>(
                            dd.resultdownloadlink !== "na" ? <Link to="../ResultDownload" onClick={()=>{ResultDownloadfun(dd)}} className='jobslink' style={{display:"block"}}><li>{dd.jobtitle}</li></Link> : ""
                        )
                    ) : window.location="/search-jobs.com"
                } 
            </div> 
            
        </div>
    );
}
export default Results;